import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef, useState } from 'react';
import { AuthService } from 'src/services/AuthService';

import { clearAccessTokenCookie } from './auth.helper';

export const useAuth = () => {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [isReady, setIsReady] = useState(false);
  const wasAuthenticated = useRef(false);

  AuthService.setInstance(getAccessTokenSilently);

  useEffect(() => {
    if (wasAuthenticated.current && !isAuthenticated) {
      clearAccessTokenCookie();
    }
    wasAuthenticated.current = isAuthenticated;
  }, [isAuthenticated]);

  useEffect(() => {
    (async () => {
      try {
        if (!isAuthenticated) {
          await AuthService.getInstance().refreshToken();
        }
      } catch (error) {
        console.warn(error);
      } finally {
        setIsReady(true);
      }
    })();
  }, [isAuthenticated]);

  return {
    isLoading: isLoading || !isReady,
    isAuthenticated: isAuthenticated,
  };
};
